export default __webpack_public_path__ + "static/media/guide_042.9630fbf8.md";